import React from 'react';

//Variables auxiliares:
let executionTimeInteval = 10000;

//Scripts auxiliares:
let dateFormatter = require('../../../tools/formatters/dateFormatter');

//Estilos base:
let paragraphBaseStyle = { fontSize: "1.15em", textTransform: "none" };

class ElapsedTimeLabel extends React.Component {

    constructor() {
        super();

        this.state = {
            elapsedTimeString: "..."
        }
    }

    componentDidMount() {
        this.interval = setInterval(() => this.executeTask(), executionTimeInteval);
        this.setState({ elapsedTimeString: dateFormatter.getDatesInterval(this.props.referenceDate, new Date()) });
    }

    render() {
        return (
            <React.Fragment>
                <p style={paragraphBaseStyle}>Tiempo transcurrido:</p>
                <p style={{ ...paragraphBaseStyle, paddingLeft: 30, fontSize: "0.9em" }}
                    dangerouslySetInnerHTML={{ __html: this.state.elapsedTimeString }}></p>
            </React.Fragment>
        );
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    //Operative methods for asynchronous tasks:
    executeTask = () => {
        let elapsedTimeString = dateFormatter.getDatesInterval(this.props.referenceDate, new Date());
        this.setState({ elapsedTimeString: elapsedTimeString });
    }
}

export default ElapsedTimeLabel;